import moment from 'moment';

export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        title: entity.title || '',
        description: entity.description || '',
        platform: entity.platform || 'kiosk',
        brandKey: entity.brandKey || null,
        startDate: entity.startDate || moment.utc().startOf('day'),
        endDate: entity.endDate || moment.utc().startOf('day').add(7, 'days'),
        chainId: entity.chainId || null,
        branchIds: entity.branchIds || [],
        meta: entity.meta || {}
    };
};
